import React from 'react'
import styles from './Service.module.css'
import ServiceCard from './ServiceCard'

export default function Service() {
    const cards = [
        {
            className: styles.service1,
            title: '求人',
            description:
                '求人は作り放題で、求人掲載費用は無料、掲載期限もなしで、想いが伝わる求人を作れます。',
        },
        {
            className: styles.service2,
            title: '無料スカウト',
            description:
                '採用したい人材の業種、職種を指定して無料でスカウトを送れます。',
        },
        {
            className: styles.service3,
            title: '会社紹介',
            description:
                '会社の紹介ページを無料で作成。事業内容、こだわり、メンバーをアピールできます。',
        },
        {
            className: styles.service4,
            title: 'ブランド紹介',
            description:
                'ブランドの紹介ページを無料で作成。事業内容、こだわり、メンバーをアピールできます。',
        },
        {
            className: styles.service5,
            title: (
                <>
                    エージェント
                    <br />
                    サポート
                </>
            ),
            description:
                '募集要件にマッチした飲食人材を弊社キャリアアドバイザーが厳選してご推薦いたします。',
        },
        {
            className: styles.service6,
            title: '求人連携',
            description:
                '作成頂いた求人をGoogle for Jobs、Indeedなどの求人媒体に連携して出稿できます。',
        },
        {
            className: styles.service7,
            title: 'SNS配信',
            description:
                '作成頂いた求人をInstagram、Facebook、TwitterなどのSNS媒体に連携して出稿できます。',
        },
    ]

    return (
        <section className={styles.service}>
            <div className={styles.serviceFirst}>
                <h2 className={styles.serviceText1}>
                    <span className={styles.orange}>
                        業界初、
                        <br />
                        飲食人材
                    </span>
                    へのアプローチが
                    <br />
                    ここまでできて、
                    <span className={styles.orange}>コストゼロ</span>
                </h2>
                <p className={styles.small}>※採用決定で初めて費用発生</p>
                <div className={styles.serviceImage}>
                    <img
                        src='/pages/business/foodslabo/service_image_v1.png'
                        alt='Foodslaboのイメージ画像'
                    />
                </div>
                <p className={styles.serviceText2}>
                    求人、スカウトからエージェントサポートまでの全てのアプローチ機能を、採用決定までコストゼロでご利用いただけます。登録者数は業界最大規模で、経験業種はイタリアン、フレンチ、和食、寿司からカフェ、ベーカリーまで、職種は店長、料理長、ホール/キッチンスタッフはもちろん、本社の営業職、スーパーバイザーまで、豊富な経験を持つ正社員の飲食人材にアプローチ出来るのが、採用DXプラットフォームです。
                </p>
            </div>
            <div className={styles.serviceSecond}>
                <div className={styles.serviceWhiteBg}>
                    <ul className={styles.serviceList}>
                        {cards.map((card, index) => (
                            <ServiceCard
                                key={index}
                                className={card.className}
                                title={card.title}
                                description={card.description}
                            />
                        ))}
                        <li className={styles.servicePcNone}>
                            <img src='/pages/business/foodslabo/service_icon_8_v1.png' />
                        </li>
                    </ul>
                </div>
                <div className={styles.serviceBg}></div>
            </div>
        </section>
    )
}
